<template>
    <div class="requests">
        <ul class="list-group" style="list-style: none;">
            <li v-bind:key="request.id" v-for="request in this.requests">
                {{ request.display_type }} Request <a href="javascript://void(0)" @click="viewRequest(request.id)">{{ request.display_id }}</a> <span v-html="request.status_label"></span>
            </li>
        </ul>
        <p v-if="this.loading === false && this.requests.length === 0">No Requests to Display</p>
    </div>
</template>

<script>
    export default {
        props: {
            user_id: {
                required: false,
                type: String
            },

            base_url: {
                required: true,
                type: String
            }
        },

        data(){
            return {
                loading: true,
                requests: []
            };
        },

        mounted(){
            if ( this.user_id ) {
                this.loadRequests()
                    .catch( this.$root.handleErrors )
                    .finally( () => {
                        this.loading = false;
                    } );
            } else {
                this.loading = false;
            }
        },

        methods: {
            loadRequests() {
                var url = '/api/users/' + this.user_id + '/compensationRequests';
                return axios.get( url )
                    .then( ( response ) => {
                        this.requests = response.data
                    } )
                    .catch( this.$root.handleErrors );
            },

            viewRequest( request_id ) {
                window.location.href = this.base_url + '/compensationRequests/' + request_id;
            }
        }
    }
</script>
